module.exports = __webpack_public_path__ + "img/ic_google_pay.abefcbea.svg";